/**
 * Accesso degli utenti "area amministrazione".
 *
 * Chi ha solo ruoli dell'area amministrativa resta confinato a /amministrazione,
 * salvo i moduli concessi esplicitamente (user_module_overrides).
 *
 * Predicato unico condiviso da ProtectedRoute, Header e MainLayout: prima era
 * duplicato con tre definizioni divergenti.
 */

type HasRole = (role: string) => boolean;
type HasModule = (code: string) => boolean;

const ADMIN_AREA_ROLES = ['amministrazione', 'collaboratore_admin'];

const OPERATIVE_ROLES = [
  'admin', 'super-admin', 'educatore', 'capogruppo',
  'assistente', 'assistente_rmna', 'shop',
];

/** true se l'utente ha solo ruoli dell'area amministrativa (nessun ruolo operativo). */
export function isAdminAreaOnlyUser(hasRole: HasRole): boolean {
  return ADMIN_AREA_ROLES.some(hasRole) && !OPERATIVE_ROLES.some(hasRole);
}

const ADMIN_AREA_BASE_PREFIX = '/amministrazione';

const matchesPrefix = (pathname: string, prefix: string) =>
  pathname === prefix || pathname.startsWith(prefix + '/');

/** true per /amministrazione e sottopagine: sempre consentite, nessun modulo richiesto. */
export function isAdminAreaBaseRoute(pathname: string): boolean {
  return matchesPrefix(pathname, ADMIN_AREA_BASE_PREFIX);
}

/** Prefissi di route raggiungibili da un utente solo-area-amministrazione. */
export function adminAreaAllowedPrefixes(hasModule: HasModule): string[] {
  const prefixes = [ADMIN_AREA_BASE_PREFIX];
  if (hasModule('shop')) prefixes.push('/shop');
  return prefixes;
}

export function isPathAllowedForAdminArea(pathname: string, hasModule: HasModule): boolean {
  return adminAreaAllowedPrefixes(hasModule).some(prefix => matchesPrefix(pathname, prefix));
}
